import { SF_BASE_URL } from '../../lib/order-constants';

interface Props {
  isOpen: boolean;
  accountId: string;
  accountName: string;
  onClose: () => void;
  onAdd: () => void;
}

/**
 * Inline-add met SF-fallback voor B2B-accounts zonder contactpersonen.
 *
 * Voor zakelijke orders is een contactpersoon verplicht — voor follow-up,
 * attribution en SF-data-hygiëne. Primary CTA opent inline AddContactDialog;
 * SF-deeplink blijft als secundaire fallback voor edge-cases (RecordType-switch,
 * Owner-wissel) waar de Office-app nog geen UI voor heeft.
 */
export function MissingContactDialog({ isOpen, accountId, accountName, onClose, onAdd }: Props) {
  if (!isOpen) return null;

  const sfNewContactUrl = `${SF_BASE_URL}/lightning/o/Contact/new?defaultFieldValues=AccountId=${accountId}`;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="px-6 py-4 border-b border-slate-200">
          <h2 className="text-base font-semibold text-slate-900">Contactpersoon ontbreekt</h2>
        </div>
        <div className="px-6 py-4 space-y-3 text-sm text-slate-700">
          <p>
            Voor een zakelijke order is een contactpersoon verplicht.{' '}
            <span className="font-medium">{accountName}</span> heeft nog geen contactpersonen.
          </p>
          <p className="text-xs text-slate-500">
            Voeg eerst een contactpersoon toe — daarna kun je de order plaatsen op naam van die persoon.
          </p>
        </div>
        <div className="px-6 py-3 border-t border-slate-200 flex items-center justify-between gap-2">
          <a
            href={sfNewContactUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-slate-500 hover:text-slate-700 underline"
          >
            of open in Salesforce
          </a>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-1.5 text-sm text-slate-600 hover:text-slate-900"
            >
              Sluiten
            </button>
            <button
              type="button"
              onClick={onAdd}
              className="px-4 py-1.5 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700 transition-colors"
            >
              Contactpersoon toevoegen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
